
export { default as X } from "./X"